import resources from './resources';

export const config = {
  interpolation: { escapeValue: false }, // React already does escaping
  lng: localStorage.getItem("I18N_LANGUAGE") || "en",
  resources,
};

export { resources };
